const Form066EN = {
    stepName: {
        Statement: "Important Notes",
        SchoolInfo: "Basic Information",
        ApplicationInfo: "Acting Appointment Details",
        Confirmation: "Confirmation",
    },
    label: {
        note: "Note",
        statement: "Personal Information Collection Statement",
        header: {
            schoolInfo: "School Information",
            personalInfo: "Personal information",
        },
        schoolName: "School Name",
        schoolCode: "School Code",
        schoolProgram: "School Session",
        contactperson: "Contact person",
        telNum: "Telephone number",
        sSDO: "SSDO",

        head1: "<b><i>Original</i></b>",
        head2: "- Funds Section, Education Bureau",
        head3: "<b><i>Duplicate</i></b>",

        contactAndTelText1: "School's contact person",
        contactAndTelText2: "and tel. no.",
        contactAndTelText3: "(for enquiry by EDB in processing this form)",
        ssdo: "- Respective Regional Education Office [Attn : ",
        ssdo2: "] Education Bureau",
        // SSDO: "SSDO",
        head4: "<b><i>Triplicate</i></b>",
        head5: "- School’s Record",

        edbConfirmCheck:
            "I confirm that the following teacher, having fulfilled the requirements set out in EDB Circular No. 8/2004 in respect of",
        edbConfirmCheck2:
            "acting appointment, is eligible for advancing the acting-up rate from 90% to 100% of the difference between",
        edbConfirmCheck3:
            "substantive salary and the minimum salary of the higher rank in which",
        edbConfirmCheck4:
            "continues to act till the end of this acting appointment as follows:",

        englishName: "Name of Teacher in English",
        chineseName: "Name of Teacher in Chinese",
        HKICNo: "HKIC No.",
        SRN: "SRN",
        rank: "Substantive Rank",
        AppointRank: "Rank of Acting Appointment",
        startDate: "Start date of Acting period",
        effectDate: "Effective Date for 100% Acting-up Rate",
        endDate: "End date of Acting period",
        isLeave:
            "The above teacher has taken leave / is absent lasting for a continuous period of 30 calendar days or more, from_____________(dd/mm/yyyy) to_____________(dd/mm/yyyy). I confirm that the above calculation of effective date for advancement of the acting-up rate to 100% has taken into consideration of the effect of such period of leave / absence on the calculation of the first 180 calendar days as set out in the Appendix of the EDB Circular No. 8/2004.",
        isLeave1:
            "The above teacher has taken leave / is absent lasting for a continuous period of 30 calendar days or more, from ",
        isLeave2: " to ",
        isLeave3:
            ". I confirm that the above calculation of effective date for advancement of the acting-up rate to 100% has taken into consideration of the effect of such period of leave/ absence on the calculation of the first 180 calendar days as set out in the Appendix of the EDB Circular No. 8/2004.",
        leaveStartDate: "From",
        leaveEndDate: "To",
        isConfirm:
            "I confirm that the above calculation of effective date for advancement of the acting-up rate to 100% has taken into consideration of the effect of such period of leave/ absence on the calculation of the first 180 calendar days as set out in the Appendix of the EDB Circular No. 8/2004.",
        dialogBtn: "CLOSE",
        remindWords:
            "Please revise the acting allowance for the above teacher accordingly.",

        termsCon1:
            'I have read the "Personal Information Collection Statement" and fully understand its content.',
        termsCon2:
            'I understand that an "iAM Smart+" account is required for processing the application.',
        titleOption: {
            his: "his",
            her: "her",
        },
        titleOption2: {
            his: "he",
            her: "she",
        },
    },
    noteList: {
        textOne:
            "Please read the Personal Information Collection Statement carefully before completing this form.",
        textTwo:
            "Please ensure the content of this form is made known to the teacher and he/she has read the Personal Information Collection Statement.",
        textThree:
            "EDB will perform pre-processing entitlement checking on each acting appointment. If the acting appointment of staff would exceed the approved entitlement of teaching staff of the school on the relevant acting appointment date, no Salaries Grant with respect to that acting appointment will be paid to the school until the acting appointment is confirmed in order.",
    },
    labelStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    certificationList: {
        text1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        text2: "processing employment-related matters;",
        text3: "processing payment of Salaries Grant and other government funding;",
        text4: "calculation of provident fund contribution;",
        text5: "auditing;",
        text6: "conducting research and compiling statistics to facilitate planning of education services;",
        text7: "processing matters relating to the development of the education profession;",
        text8: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        text9: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        text10: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        text11: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form. This is however subject to payment of a fee.",
        text12: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
    },
    errorMsg: {
        // maxRule: "Maximum character length: {{max}} digits",
        tel: {
            digit: "It needs to be 8-15 digits",
            rule: "Need to match telephone number rule",
            faxRule: "Need to match fax number rule",
        },
        date: {
            effectLimit: "The effective date shall be within the Acting period",
            leaveLimit: "The field shall be within the Acting period",
        },
        codeDigit: "This field must be exactly {{digit}} digits",
    },
};
export default Form066EN;
